import { render } from "./Nonfiction.vue?vue&type=template&id=2fecdcaf&scoped=true"
import script from "./Nonfiction.vue?vue&type=script&lang=js"
export * from "./Nonfiction.vue?vue&type=script&lang=js"

import "./Nonfiction.vue?vue&type=style&index=0&id=2fecdcaf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2fecdcaf"

export default script